import initialState from '@/core/store/initialState';
import { isObj, isArr, isNull } from '@/core/utils';

/**
* @description Is valid
* @param books
* @returns {boolean}
*/
const isValid = (books) => isObj(books)
  && isNull(books.draft)
  && isNull(books.filters)
  && isArr(books.items)
  && isNull(books.size)
  && isObj(books.activeItem);

/**
* @description Init state
* @param initialState
* @returns {*}
*/
const initState = (initialState) => {
  if (!isValid(initialState)) {
    throw Error('Invalid initial stories books state');
  }

  const { items, size, activeItem, draft, filters } = initialState;
  return {
    items,
    size,
    activeItem,
    draft,
    filters,
  };
};

/**
* @description Getters
* @type {*}
*/
export const getters = {
  items: ({ items }) => items,
  size: ({ size }) => size,
  activeItem: ({ activeItem }) => activeItem,
  draft: ({ draft }) => draft,
  filters: ({ filters }) => filters,
};

const actions = {
  setDraft: ({ commit }, nextDraft) => {
    commit('DRAFT', nextDraft);
  },
  resetDraft: ({ commit }) => {
    commit('DRAFT', null);
  },
  setFilters: ({ commit }, nextFilters) => {
    commit('FILTER', nextFilters);
  },
  reset: ({ commit }) => (
    commit('SET', initialState.storiesBooks)
  ),
  set: ({ commit }, books) => {
    commit('SET', books);
  },
};

const mutations = {
  SET(state, books) {
    state.token = books.token;
    state.user = books.user;
    state.role = books.role;
  },
  DRAFT(state, draft) {
    state.draft = draft;
  },
  FILTER(state, filters) {
    state.filters = filters;
  },
};

export default initialState => ({
  namespaced: true,
  state: initState(initialState),
  getters,
  actions,
  mutations,
});
